import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

// define the translations
const messages = {
  en: {
    validation: {
      maxLength: "Maximum {max} characters",
    },
    notification: {
      success: "Success",
      error: "Error",
      warning: "Warning",
      info: "Info",
      successMessage: "Operation completed successfully",
      errorMessage: "An error has occurred. Please try again",
      warningMessage: "Operation interrupted",
      infoMessage: "",
    },
    login: {
      interest: {
        top: "Our interest is.",
        bottom: "your interest.",
      },
      email: "E-mail address",
      password: "Password",
      rememberMe: "Remember me",
      signIn: "Sign in",
      invalidEmailOrPassword: "Invalid password or email.",
      signInFailed: "Sign in failed. Please try again.",
      required: "This field is required.",
      invalidEmail: "Invalid email.",
      forgotPassword: "Forgot Password?",
      resetPassword: "Reset Password",
      resetFailed: "Password reset failed. Please try again.",
      backToLogin: "Back to Login",
      resetSuccess:
        "A new, provisional password has been assigned to your account. Please check your email.",
      register: "Register Here",
      termsRejected: "You must accept the terms and conditions to continue.",
      termsError: "Error accepting terms and conditions. Please try again.",
    },
    sidebar: {
      profile: "Profile",
      newSubmission: {
        top: "New",
        bottom: "Submission",
      },
      dashboard: "Dashboard",
      history: "History",
      team: "Team",
      companies: "Companies",
      activities: "Activities",
      partners: "Partners",
      dropdown: "Dropdown",
      logout: "Log Out",
    },
    profile: {
      userProfileCard: {
        editProfile: "Edit Profile",
      },
      userInformationCard: {
        personalInformation: "Personal Information",
        name: "Name",
        email: "E-mail Address",
        phone: "Phone Number",
        saveChanges: "Save changes",
        nameRequired: "Name is required",
        nameMinLength: "Name must be at least 5 characters",
        emailRequired: "E-mail is required",
        emailInvalid: "E-mail must be valid",
        phoneRequired: "Phone number is required",
        profileUpdated: "Profile updated successfully.",
        updateFailed: "Update failed. Please try again.",
      },
      userPasswordCard: {
        currentPassword: "Current Password",
        newPassword: "New Password",
        updatePassword: "Update Password",
        saveChanges: "Save changes",
        passwordRequired: "Password is required",
        passwordMinLength: "Password must be at least 5 characters",
        passwordUpdated: "Password updated successfully.",
        passwordUpdateFailed: "Update failed. Incorrect password.",
        generalUpdateFailed: "Update failed. Please try again.",
      },
      jobInformationCard: {
        jobInformation: "Job Information",
        jobTitle: "Job Title",
        entryDate: "Entry Date",
        saveChanges: "Save Changes",
        jobUpdated: "Job information updated successfully.",
        updateFailed: "Update failed. Please try again.",
        department: "Department",
        intake: "Intake",
        inspections: "Inspections",
        estimation: "Estimation",
        roofer_relations: "Roofer Relations",
        check_support: "Check Support",
        appraisal: "Appraisal",
        management: "Management",
        supplementing: "Supplementing",
        sales: "Sales",
        stanley: "Stanley",
        office: "Office",
        developer: "Developer",
        more_documents: "More Documents",
        checks: "Checks",
        claim_updates: "Claim Updates",
        only_urgent: "Only Urgent",
        attorney_update: "Attorney Update",
        guilfe: "Guilfe",
      },
    },
    projects: {
      newProjectBasicInformation: {
        newSubmission: "New Submission",
        letsGetStarted: "LET’S GET STARTED",
        enterUniqueName:
          "Enter a unique name. This can be an address, client name, or other info you can identify this scope by later.",
        insuredName: "Insured First Name and Last Name",
        address: "Address",
        addressLine2: "Address Line 2",
        city: "City",
        state: "State",
        zipCode: "Zip Code",
        company: "Company",
        confirmProjectLocation: "Confirm Project Location",
        errorOccurred: "An error has occurred, please try again",
        nameRequired: "Name is required",
        nameMinLength: "Name must be at least 5 characters",
        addressRequired: "Address is required",
        addressMinLength: "Address must be at least 5 characters",
        cityRequired: "City is required",
        cityMinLength: "City must be at least 4 characters",
        stateRequired: "State is required",
        stateMinLength: "State must be at least 2 characters",
        zipRequired: "Zip is required",
        zipMustBeNumber: "Zip Code must be a number",
        companyRequired: "Company is required",
      },
      newProjectChargeData: {
        newSubmission: "New Submission",
        createNewFile: "Create New Submission",
        customer: "Customer",
        information: "Information",
        customerDescription:
          "Please fill out your contact details and address accurately for efficient communication and service delivery.",
        uploadNow: "Upload Now",
        external: {
          top: "External",
          bottom: "Damages",
          description: "Upload all relevant files related to external damages.",
        },
        internal: {
          top: "Internal",
          bottom: "Damages",
          description: "Upload all relevant files related to internal damages.",
        },
        project: {
          top: "Project",
          bottom: "Documents",
          description:
            "Upload any necessary documents like permits, insurance claims, or previous repair records for a complete view of the project.",
        },
        submitClaim: "Submit Claim",
        goToDashboard: "Go to Dashboard",
        claimSubmitted: "Claim submitted successfully",
        completeLater:
          "It's essential to complete at least the customer information to enable the ‘Complete Later’ button. Your cooperation ensures smooth progress.",
      },
      cards: {
        customerInformation: {
          newSubmission: "New Submission",
          customerInformation: "Customer Information",
          customerName: "Customer Name *",
          lossAddress: "Loss address",
          address: "Address *",
          addressLine2: "Address Line 2",
          city: "City *",
          state: "State *",
          zipCode: "Zip Code *",
          insuredMailingAddress: "Insured Mailing Address",
          useLossAddress: "Use Loss Address as Mailing Address",
          contactInfo: "Contact Info",
          customerEmail: "Customer E-mail Address *",
          customerPhone: "Customer Cell Phone Number *",
          additionalInsuredName: "Additional Insured Name",
          insuranceCompany: "Insurance Company",
          policyNumber: "Policy Number",
          claimNumber: "Claim Number",
          causeOfLoss: "Cause of Loss",
          claimInspected:
            "Has This Claim Been Inspected By The Insurance Company?",
          claimReported:
            "Has This Claim Been Reported To The Insurance Company?",
          dateOfLoss: "Date of Loss Or Storm",
          currentClaimStatus: "Current Status of Claim",
          stateOfEmergency:
            "Did This Weather Event Cause The Governor To Declare A State Of Emergency?",
          companyCamLinks: "CompanyCam Links",
          descriptionOfLoss: "Description of Loss / Claim Notes",
          backToOptions: "Back To Options",
          confirmInformation: "Confirm Information",
          errorOccurred: "An error has occurred, please try again",
          customerNameRequired: "Customer name is required",
          customerNameMinLength: "Customer name must be at least 4 characters",
          addressRequired: "Address is required",
          addressMinLength: "Address must be at least 5 characters",
          cityRequired: "City is required",
          cityMinLength: "City must be at least 4 characters",
          stateRequired: "State is required",
          stateMinLength: "State must be at least 2 characters",
          zipRequired: "Zip is required",
          zipNumber: "Zip Code must be a number",
          emailRequired: "E-mail is required",
          emailValid: "E-mail must be valid",
          phoneRequired: "Phone number is required",
          phoneMinLength: "Phone number must be at least 10 characters",
          causeOfLossOptions: {
            hail: "Hail",
            wind: "Wind",
            hailWind: "Hail & Wind",
            hurricaneWind: "Hurricane Wind",
            hurricaneFlood: "Hurricane Flood",
            flood: "Flood",
            fire: "Fire",
            smoke: "Smoke",
            fireSmoke: "Fire & Smoke",
            fallenTree: "Fallen Tree",
            lightning: "Lightning",
            tornado: "Tornado",
            vandalism: "Vandalism",
            marine: "Marine",
            water: "Water",
            other: "Other",
          },
          claimStatusOptions: {
            new: "New",
            reopen: "Reopen",
            denied: "Denied",
            underDeductible: "Under Deductible",
          },
          stateOfEmergencyOptions: {
            stateOfEmergency:
              "State of Emergency (Hurricane 1 year ago or less)",
            nonEmergency: "Non-Emergency",
          },
          booleanOptions: {
            yes: "Yes",
            no: "No",
          },
          hasMortgage: "Does the homeowner have a mortgage?",
          mortgageName: "Mortgage Company Name",
          mortgageNameMinLength:
            "Mortgage Company Name must be at least 5 characters",
          propertyInteriorWet: "Is the interior of the property wet/moist?",
        },
        documents: {
          uploadDocuments: "UPLOAD DOCUMENTS",
          uploadInstructions: "Please upload your documents below",
          uploadLabel: "Upload Documents",
          selectFiles: "Select your files",
          more: "more",
          backToOptions: "Back To Options",
          confirmInformation: "Confirm Information",
          errorOccurred: "An error has occurred, please try again",
          noFilesSelected: "No files selected",
          invalidFormat: "Invalid file format",
          fileSizeExceeded: `File size should be less than ${process.env.VUE_APP_WEIGHT_OF_FILES}MB`,
        },
        file: {
          uploadFiles: "UPLOAD FILES",
          uploadInstructions: "Please upload your files below",
          uploadLabel: "Upload files",
          selectFiles: "Select your files",
          more: "more",
          backToOptions: "Back To Options",
          confirmInformation: "Confirm Information",
          errorOccurred: "An error has occurred, please try again",
          noFilesSelected: "No files selected",
          invalidFormat: "Invalid file format",
          fileSizeExceeded: `File size should be less than ${process.env.VUE_APP_WEIGHT_OF_FILES}MB`,
        },
        internalFile: {
          uploadFiles: "UPLOAD FILES",
          uploadInstructions: "Please upload your files below",
          uploadLabel: "Upload files",
          selectFiles: "Select your files",
          more: "more",
          backToOptions: "Back To Options",
          confirmInformation: "Confirm Information",
          errorOccurred: "An error has occurred, please try again",
          noFilesSelected: "No files selected",
          invalidFormat: "Invalid file format",
          fileSizeExceeded: `File size should be less than ${process.env.VUE_APP_WEIGHT_OF_FILES}MB`,
        },
      },
    },
    dashboard: {
      header: {
        totalClaims: "Total Claims",
        intakePending: "Intake Pending",
        intakeRejected: "Intake Rejected",
        claimOpen: "Claim Open",
        claimClosed: "Claim Closed",
        totalWorkers: "Total Workers",
        intakeApproved: "Intake Approved",
        periods: {
          last_24h: "24h",
          last_7d: "7 days",
          last_30d: "30 days",
          all: "All",
        },
        current: "Currently",
        periodCaptions: {
          last_24h: "In the last 24 hours",
          last_7d: "In the last 7 days",
          last_30d: "In the last 30 days",
          all: "Currently",
        },
      },
      table: {
        recentHistory: "Recent History",
        fullHistory: "Full History",
        fullView: "Full View",
        headers: {
          number: "SUB#",
          name: "Name",
          LOR: "LOR",
          intake: "Intake",
          status: "Status",
          address: "Address",
          created_at: "Created Date",
          company_name: "Company",
        },
      },
      activities: {
        title: "Activities",
        newUpdate: "New Update",
        at: "At",
      },
      partners: {
        title: "Partner Spotlight",
        subtitle: "Trusted partners. Exclusive resources for NVA contractors.",
        viewAll: "View All Partners",
      },
    },
    partners: {
      search: "Search",
      newPartner: "New Partner",
      editPartner: "Edit Partner",
      edit: "Edit",
      delete: "Delete",
      deleteTitle: "Delete Partner",
      deleteConfirm: "Are you sure you want to delete {company}?",
      image: "Banner Image",
      imageHint: "JPG, PNG or WebP · max 10 MB · recommended 1800×300 px",
      imageInfo: {
        title: "Banner image requirements",
        formats: "Format: JPG, PNG or WebP.",
        size: "Maximum size: 10 MB.",
        ratio:
          "Wide banner: width between 4 and 8 times the height. Recommended 1800×300 px.",
        spotlight:
          "Required to show the partner on the dashboard. Clicking it opens the partner's website.",
      },
      spotlight: "Show in dashboard Spotlight",
      spotlightHint:
        "Only one partner is shown on the dashboard; this replaces the current one.",
      spotlightChip: "Spotlight",
      close: "Close",
      save: "Save",
      errorOccurred: "An error occurred. Please try again.",
      headers: {
        company: "Company",
        service: "Service",
        contact: "Contact/Agent",
        phone_number: "Phone",
        email: "Email",
        website: "Website",
      },
      validation: {
        required: "This field is required",
        email: "Email must be valid",
        website: "Website must start with http:// or https://",
        imageRequired:
          "An image is required to show this partner on the dashboard",
        imageType: "Only JPG, PNG or WebP images are allowed",
        imageSize: "Image must be 10 MB or smaller",
        imageRatio:
          "Image must be a wide banner (between 4:1 and 8:1, recommended 1800×300 px)",
      },
    },
    companies: {
      search: "Search",
      newCompany: "New Company",
      name: "Name",
      email: "Email",
      address: "Address",
      phoneNumber: "Phone Number",
      types: "Types",
      sellers: "Sellers",
      representative: "Representative",
      notes: "Notes",
      errorOccurred: "An error has occurred, please try again",
      close: "Close",
      save: "Save",
      createAdmin: "Create Admin",
      editCompany: "Edit Company",
      companyHistory: "Company History",
      headers: {
        name: "Name",
        email: "Email",
        address: "Address",
        phone_number: "Phone Number",
        created_at: "Created Date",
        company_type: "Company Type",
        sellers: "Sellers",
        representative: "Representative",
      },
      validation: {
        name: {
          required: "Name is required",
          minLength: "Name must be at least 3 characters",
        },
        email: {
          required: "Email is required",
          valid: "Email must be valid",
        },
        address: {
          required: "Address is required",
          minLength: "Address must be at least 5 characters",
        },
        phone: {
          required: "Phone number is required",
          minLength: "Phone number must be at least 5 characters",
        },
      },
      typesOptions: {
        roofing: "Roofing",
        mitigation: "Mitigation",
        remodeling: "Remodeling",
        other: "Other",
      },
      sellersOptions: {
        "1-5": "1-5",
        "6-15": "6-15",
        "15+": "15+",
      },
    },
    team: {
      teamInfo: {
        search: "Search",
        newMember: "New Member",
        headers: {
          entry_date: "Entry Date",
          job_title: "Job Title",
          claims: "Claims",
          name: "Name",
          email: "Email",
          phone: "Phone",
        },
      },
      createMember: {
        newMember: "New member",
        name: "Name",
        email: "Email",
        phoneNumber: "Phone Number",
        password: "Password",
        confirmationPassword: "Confirmation Password",
        entryDate: "Entry Date",
        jobTitle: "Job Title",
        confirmAccount: "Confirm Account",
        accountCreated: "The account has been created.",
        createAnotherAccount: "Create another account",
        viewCompanies: "View Companies",
        viewTeam: "View team",
        accountCreationFailed: "Account creation failed.",
        tryAgain: "Try again",
        validation: {
          name: {
            required: "Name is required",
            minLength: "Name must be at least 5 characters",
          },
          email: {
            required: "E-mail is required",
            valid: "E-mail must be valid",
          },
          phone: {
            required: "Phone is required",
            minLength: "Phone must be at least 5 characters",
          },
          password: {
            required: "Password is required",
            minLength: "Password must be at least 5 characters",
          },
          confirmationPassword: {
            required: "Confirmation Password is required",
            match: "Passwords must match",
          },
          date: {
            required: "Date is required",
          },
          jobTitle: {
            required: "Job Title is required",
            minLength: "Job Title must be at least 5 characters",
          },
        },
      },
    },
    history: {
      principalHistory: {
        recentHistory: "Recent History",
        fullHistory: "Full History",
        headers: {
          number: "SUB#",
          name: "Name",
          LOR: "LOR",
          intake: "Intake",
          status: "Status",
          address: "Address",
          created_at: "Created Date",
          company_name: "Company",
        },
        fullView: "Full View",
        editName: "Edit Name",
        editProject: "Edit Project",
        close: "Close",
        save: "Save",
        validation: {
          name: {
            required: "Name is required",
            minLength: "Name must be at least 5 characters",
          },
        },
        errorOccurred: "An error has occurred, please try again",
        projectUpdated: "Project has been updated successfully",
        search: "Search",
        all: "All",
        pending: "Pending",
        rejected: "Rejected",
        incomplete: "Incomplete",
        status: "Open",
        negotiation: "Negotiation",
        appraisal: "Appraisal",
        depreciation: "Depreciation",
        appraisalOnly: "Appraisal Only",
        attorney: "Attorney",
        pendingNotifications: "Pending Notifications",
        filters: "Filters",
        otherFilters: "Other",
      },
      fullView: {
        details: "Details",
        contacts: "Contacts",
        files: "Files",
        forms: "Forms",
        config: "Status",
        downloadImage: "Download Image",
        editProjectName: "Edit Project Name",
        name: "Name",
        save: "Save",
        close: "Close",
        errorOccurred: "An error has occurred, please try again",
        projectUpdated: "Project name has been updated successfully",
      },
      elements: {
        header: {
          client: "Client",
          subNumber: "Company Name",
          claimStatus: "Claim Status",
          totalPayments: "Total Payments",
          lastPayment: "Last payment",
        },
        details: {
          insuredInfo: "Insured Info",
          editCustomer: "Edit Customer",
          claimInfo: "Claim Info",
          update: "Updates",
          payments: "Payment",
          timeline: "Timeline",
          name: "Name",
          email: "Email",
          phone: "Phone",
          insuredAddress: "Insured Address",
          lossAddress: "Loss Address",
          causeOfLoss: "Cause of Loss",
          lossDescription: "Loss Description / Claim Notes",
          companycamLinks: "Companycam Links",
          claimNumber: "Claim Number",
          claimStatus: "Claim Status",
          dateOfLoss: "Date of Loss or Storm",
          inspectedByInsurance: "Inspected by Insurance Company",
          reportedToInsurance: "Reported to Insurance Company",
          insuranceCompany: "Insurance Company",
          policyNumber: "Policy Number",
          stateOfEmergency: "State of Emergency",
          hasMortgage: "Has Mortgage",
          mortgageCompany: "Mortgage Company Name",
          propertyInteriorWet: "Interior of Property Wet/Moist",
          yes: "Yes",
          no: "No",
          payment: {
            total: "Total",
            amount: "Payment Amount",
            description: "Payment Description",
            detail: "Payment Detail",
            upload: "Upload files",
            newPayment: "New Payment",
            attachments: "Attachments",
            reply: "Reply",
            replyDetail: "Reply Detail",
            sendReply: "Send Reply",
            error: "An error has occurred, please try again",
            replyError:
              "There was an error submitting your reply. Please try again.",
            department: "Department",
            office: "Office",
            intake: "Intake",
            inspections: "Inspections",
            estimation: "Estimation",
            roofer_relations: "Roofer Relations",
            check_support: "Check Support",
            appraisal: "Appraisal",
            management: "Management",
            supplementing: "Supplementing",
            sales: "Sales",
            stanley: "Stanley",
            more_documents: "More Documents",
            checks: "Checks",
            claim_updates: "Claim Updates",
            only_urgent: "Only Urgent",
            attorney_update: "Attorney Update",
            guilfe: "Guilfe",
            validation: {
              amountRequired: "Payment Amount is required",
              descriptionRequired: "Payment Description is required",
              detailRequired: "Payment Detail is required",
              maxFiles: `You can only upload up to ${process.env.VUE_APP_NUMBER_OF_FILES} files`,
              maxFileSize: `Each file must be less than ${process.env.VUE_APP_WEIGHT_OF_FILES}MB`,
              replyRequired: "Reply Detail is required",
              departmentRequired: "Department is required",
            },
            deletePayment: "Delete Payment",
            deletePaymentConfirmation:
              "Are you sure you want to delete this payment?",
            deleteComment: "Delete Comment",
            deleteCommentConfirmation:
              "Are you sure you want to delete this comment?",
            confirm: "Confirm",
            cancel: "Cancel",
          },
          updates: {
            threadDetail: "Thread Detail",
            upload: "Upload files",
            createThread: "Create Thread",
            attachments: "Attachments",
            reply: "Reply",
            replyDetail: "Reply Detail",
            sendReply: "Send Reply",
            error: "An error has occurred, please try again",
            replyError:
              "There was an error submitting your reply. Please try again.",
            department: "Department",
            office: "Office",
            intake: "Intake",
            inspections: "Inspections",
            estimation: "Estimation",
            roofer_relations: "Roofer Relations",
            check_support: "Check Support",
            appraisal: "Appraisal",
            management: "Management",
            supplementing: "Supplementing",
            sales: "Sales",
            stanley: "Stanley",
            more_documents: "More Documents",
            checks: "Checks",
            claim_updates: "Claim Updates",
            only_urgent: "Only Urgent",
            attorney_update: "Attorney Update",
            guilfe: "Guilfe",
            validation: {
              threadRequired: "Thread Detail is required",
              maxFiles: `You can only upload up to ${process.env.VUE_APP_NUMBER_OF_FILES} files`,
              maxFileSize: `Each file must be less than ${process.env.VUE_APP_WEIGHT_OF_FILES}MB`,
              replyRequired: "Reply Detail is required",
              departmentRequired: "Department is required",
            },
            deleteThread: "Delete Thread",
            deleteThreadConfirmation:
              "Are you sure you want to delete this thread?",
            deleteComment: "Delete Comment",
            deleteCommentConfirmation:
              "Are you sure you want to delete this comment?",
            confirm: "Confirm",
            cancel: "Cancel",
          },
          timelines: {
            ClaimUpdated: "Claim Updated",
            ClaimCreated: "Claim Created",
            FileUploaded: "File Uploaded",
            ContactsUpdated: "Contacts Updated",
            claimStatusUpdated: "Claim Status Updated: {status}",
            claimIntakeUpdated: "Intake Updated: {intake}",
            Comment: "Comment",
            Payment: "Payment",
            filterByDepartment: "Filter by Department",
            allDepartments: "All Departments",
            office: "Office",
            intake: "Intake",
            inspections: "Inspections",
            estimation: "Estimation",
            roofer_relations: "Roofer Relations",
            check_support: "Check Support",
            appraisal: "Appraisal",
            management: "Management",
            supplementing: "Supplementing",
            sales: "Sales",
            stanley: "Stanley",
            more_documents: "More Documents",
            checks: "Checks",
            claim_updates: "Claim Updates",
            only_urgent: "Only Urgent",
            attorney_update: "Attorney Update",
            guilfe: "Guilfe",
            other: "Other",
          },
        },
        contacts: {
          internalContacts: "Internal Contacts",
          addMoreContacts: "Add More Contacts",
          manageContacts: "Manage Contacts",
          cancel: "Cancel",
          save: "Save",
          headers: {
            name: "Name",
            job_title: "Job",
            email: "E-mail",
            phone: "Phone",
          },
        },
        files: {
          files: "Files",
          addNew: "Add New",
          folder: "Folder",
          addNewFolder: "Add New Folder",
          folderName: "Folder Name",
          cancel: "Cancel",
          save: "Save",
          upload: "Upload",
          close: "Close",
          uploadDocuments: "Upload Documents",
          selectDocuments: "Select documents",
          downloadAll: "Download as Zip",
          downloadAllImages: "Download as PDF",
          uploadLimit: `You can only upload up to ${process.env.VUE_APP_NUMBER_OF_FILES} files`,
          fileSizeLimit: `Each file must be less than ${process.env.VUE_APP_WEIGHT_OF_FILES}MB`,
          folderCreated: "Folder created successfully",
          documentUploaded: "Document uploaded successfully",
          documentDeleted: "Document deleted successfully",
          errorOccurred: "An error has occurred, please try again",
          delete: "Delete File",
          edit: "Edit Name",
          editDocument: "Edit File Name",
          documentEdited: "Document name edited successfully",
          documentName: "File Name",
          requiredName: "Name is required",
        },
        forms: {
          lor: "LOR",
          noLOR: "No Letter of Representation record found for this Project.",
          resend: "Resend",
          error: "An error has occurred, please try again",
          success: "LOR sent successfully",
          email_send_date: "Email Send Date",
          email_status: "Email Status",
          reminder_sent_date: "Reminder Sent Date",
          status: "Status",
          Sent: "Sent",
          Unsigned: "Unsigned",
          Signed: "Signed",
        },
        config: {
          editStatusAndIntake: "Edit Status and Intake",
          status: "Status",
          intake: "Intake",
          update: "Update",
          error: "An error has occurred, please try again",
          success: "Status and Intake updated successfully",
          statusOptions: {
            open: "Open",
            closed: "Closed",
            tbd: "TBD",
            inspection: "Inspection",
            negotiations: "Negotiations",
            appraisal: "Appraisal",
            settled: "Settled",
            depreciation: "Depreciation",
            appraisal_only: "Appraisal Only",
            attorney: "Attorney",
          },
          intakeOptions: {
            approved: "Approved",
            pending: "Pending",
            rejected: "Rejected",
            incomplete: "Incomplete",
          },
        },
      },
    },
    activities: {
      search: "Search",
      headers: {
        creator: "Creator",
        date: "Date",
        event: "Event",
        project: "Claim",
      },
      fullView: "Full View",
    },
    termsAndConditions: {
      title: "Terms & Conditions",
      subtitle: "National Virtual Adjusters LLC",
      content: {
        intro:
          'We value transparency, integrity, and professionalism in all vendor relationships. This acknowledgment ensures mutual understanding and protects all parties involved—National Virtual Adjusters LLC ("NVA"), licensed public adjusting firms, and you as the vendor. By agreeing to the terms below, you help us maintain high standards and ethical practices in serving homeowners.',
        statement:
          'This Acknowledgment and Disclosure Statement ("Statement") is made by the undersigned vendor ("Vendor") in connection with the provision of insurance claim leads to National Virtual Adjusters LLC ("NVA"), a company that facilitates connections between roofing contractors and licensed public adjusting firms, including but not limited to Cohen and Associates Public Adjusters Inc, and any other licensed public adjusting firm operating in any U.S. state.',
        acknowledgment:
          "By signing below, the Vendor hereby acknowledges, affirms, and agrees to the following:",
        section1: {
          title: "1. Legitimacy and Lawful Origin of Leads",
          text: "• All leads provided to National Virtual Adjusters LLC, Cohen and Associates Public Adjusters Inc, or any other licensed public adjusting firm operating in any U.S. state—whether in the past, present, or future—are obtained through legal, ethical, and transparent means.\n• No lead is fraudulent, fabricated, or intended to mislead or misrepresent the nature of the insurance claim.\n• Each lead represents a legitimate homeowner with a valid or potential property insurance claim.",
        },
        section2: {
          title: "2. No Fraud or Deception",
          text: "• Vendor shall not engage in any activity that deceives, defrauds, or misrepresents information to:\n• National Virtual Adjusters LLC or any of its members, representatives, or affiliates\n• Cohen and Associates Public Adjusters Inc or any of its licensed adjusters, staff, or representatives\n• Any other licensed public adjusting firm operating in any U.S. state\n• The homeowners who are clients or potential clients of any of the above entities\n• Vendor shall not present or describe the role of NVA in a way that may cause confusion or mislead homeowners regarding its licensing status or function.",
        },
        section3: {
          title: "3. Clear Representation to Homeowners",
          text: "• Vendor shall ensure that homeowners understand that a licensed public adjuster is responsible for handling their insurance claim.\n• Vendor acknowledges that National Virtual Adjusters LLC serves as a connector between roofing contractors and licensed public adjusting firms, including but not limited to Cohen and Associates Public Adjusters Inc and other licensed public adjusting firms in any U.S. state. NVA is not a licensed public adjuster. Vendor agrees to represent this structure accurately to help homeowners understand who is managing their claim and who is facilitating the connection.",
        },
        section4: {
          title: "4. No Business Affiliation or Conflict of Interest",
          text: "• Vendor acknowledges that there is no business partnership, joint venture, agency relationship, or employment arrangement between Vendor and either National Virtual Adjusters LLC, Cohen and Associates Public Adjusters Inc, or any other licensed public adjusting firm.\n• Any representation or implication of such a relationship is strictly prohibited and constitutes a conflict of interest.\n• Vendor shall disclose any potential conflicts of interest that may arise in connection with the leads provided.",
        },
        section5: {
          title: "5. Indemnification",
          text: "• Vendor agrees to indemnify and hold harmless National Virtual Adjusters LLC, Cohen and Associates Public Adjusters Inc, any other licensed public adjusting firm, and all their respective members, adjusters, officers, and affiliates from any claims, damages, or liabilities arising out of or related to the provision of fraudulent, misleading, or improperly obtained leads.",
        },
        section6: {
          title: "6. Understanding and Compliance",
          text: "• Vendor affirms that they have read, understood, and agreed to the terms of this Statement.\n• Vendor agrees to comply with all applicable laws, regulations, and ethical standards in the acquisition and delivery of leads.",
        },
        section7: {
          title: "7. Jurisdiction and Enforceability",
          text: "• This Statement shall be governed by and construed in accordance with the laws of the U.S. state in which the licensed public adjusting firm involved in the transaction operates.\n• However, where permissible, the parties agree to submit to the exclusive jurisdiction and venue of the courts of the State of Florida, specifically Broward County, Florida.\n• The parties agree that this Statement is legally binding and enforceable.",
        },
        section8: {
          title: "8. Audit and Verification Rights",
          text: "• National Virtual Adjusters LLC, Cohen and Associates Public Adjusters Inc, or any other licensed public adjusting firm reserve the right to request documentation or verification of lead origin and acquisition methods at any time.\n• Vendor agrees to cooperate fully with any such request to ensure compliance and transparency.",
        },
        section9: {
          title: "9. Consequences of Breach",
          text: "• Any breach of this Statement by the Vendor may result in immediate termination of the relationship with National Virtual Adjusters LLC, Cohen and Associates Public Adjusters Inc, or any other licensed public adjusting firm.\n• Termination may occur without prior notice if the breach poses a risk to legal compliance, ethical standards, or the reputation of the parties involved.",
        },
        section10: {
          title: "10. Electronic Acknowledgment Validity",
          text: "• The parties agree that acknowledgment of this Statement via electronic means—including checking a box during the vendor registration process—shall be deemed valid and enforceable under the Electronic Signatures in Global and National Commerce Act (ESIGN) and the Uniform Electronic Transactions Act (UETA).",
        },
        section11: {
          title: "11. Attorneys' Fees and Costs",
          text: "• If any party maintains or commences any action, proceeding, or motion against the other to enforce this Statement or any provision hereof, the prevailing party shall be entitled to recover its costs and expenses, including mediation fees, litigation costs, court fees, and reasonable attorneys' fees incurred in connection with such action.",
        },
        acceptance:
          "By clicking 'Accept', you acknowledge that you have read, understood, and agree to be bound by this Acknowledgment and Disclosure Statement for Lead Vendors.",
      },
      acceptMessage:
        "Please accept these terms in order to continue using the platform.",
      accept: "Accept",
      reject: "Reject",
      viewTerms: "View Terms",
      hideTerms: "Hide Terms",
    },
  },
  es: {
    validation: {
      maxLength: "Máximo {max} caracteres",
    },
    notification: {
      success: "Éxito",
      error: "Error",
      warning: "Advertencia",
      info: "Información",
      successMessage: "Operación completada con éxito",
      errorMessage: "Ha ocurrido un error. Por favor, inténtelo de nuevo",
      warningMessage: "Operación interrumpida",
      infoMessage: "",
    },
    login: {
      interest: {
        top: "Nuestro interés es",
        bottom: "tu interés.",
      },
      email: "Dirección de correo electrónico",
      password: "Contraseña",
      rememberMe: "Recuérdame",
      signIn: "Iniciar sesión",
      invalidEmailOrPassword: "Correo electrónico o contraseña inválidos.",
      signInFailed: "Error al iniciar sesión. Por favor, inténtelo de nuevo.",
      required: "Este campo es obligatorio.",
      invalidEmail: "Correo electrónico no válido.",
      forgotPassword: "¿Olvidaste tu contraseña?",
      resetPassword: "Restablecer contraseña",
      resetFailed:
        "Error al restablecer la contraseña. Por favor, inténtelo de nuevo.",
      backToLogin: "Volver al inicio de sesión",
      resetSuccess:
        "Se ha asignado una nueva contraseña provisional a su cuenta. Por favor, revise su correo electrónico.",
      register: "Regístrate aquí",
      termsRejected: "Debe aceptar los términos y condiciones para continuar.",
      termsError:
        "Error al aceptar los términos y condiciones. Por favor, inténtelo de nuevo.",
    },
    sidebar: {
      profile: "Perfil",
      newSubmission: {
        top: "Nuevo",
        bottom: "Proyecto",
      },
      dashboard: "Tablero",
      history: "Historial",
      team: "Equipo",
      companies: "Empresas",
      activities: "Actividades",
      partners: "Socios",
      dropdown: "Desplegar",
      logout: "Cerrar Sesión",
    },
    profile: {
      userProfileCard: {
        editProfile: "Editar Perfil",
      },
      userInformationCard: {
        personalInformation: "Información Personal",
        name: "Nombre",
        email: "Dirección de correo electrónico",
        phone: "Número de teléfono",
        saveChanges: "Guardar cambios",
        nameRequired: "El nombre es obligatorio",
        nameMinLength: "El nombre debe tener al menos 5 caracteres",
        emailRequired: "El correo electrónico es obligatorio",
        emailInvalid: "El correo electrónico debe ser válido",
        phoneRequired: "El número de teléfono es obligatorio",
        profileUpdated: "Perfil actualizado con éxito.",
        updateFailed: "Error al actualizar. Por favor, inténtelo de nuevo.",
      },
      userPasswordCard: {
        currentPassword: "Contraseña Actual",
        newPassword: "Nueva Contraseña",
        updatePassword: "Actualizar Contraseña",
        saveChanges: "Guardar cambios",
        passwordRequired: "La contraseña es obligatoria",
        passwordMinLength: "La contraseña debe tener al menos 5 caracteres",
        passwordUpdated: "Contraseña actualizada con éxito.",
        passwordUpdateFailed: "Error al actualizar. Contraseña incorrecta.",
        generalUpdateFailed:
          "Error al actualizar. Por favor, inténtelo de nuevo.",
      },
      jobInformationCard: {
        jobInformation: "Información del Trabajo",
        jobTitle: "Título del Trabajo",
        entryDate: "Fecha de Ingreso",
        saveChanges: "Guardar Cambios",
        jobUpdated: "Información del trabajo actualizada con éxito.",
        updateFailed: "Error al actualizar. Por favor, inténtelo de nuevo.",
        department: "Departamento",
        intake: "Admisión",
        inspections: "Inspecciones",
        estimation: "Estimación",
        roofer_relations: "Relaciones con Techadores",
        check_support: "Soporte de Cheques",
        appraisal: "Evaluación",
        management: "Gestión",
        supplementing: "Suplementación",
        sales: "Ventas",
        stanley: "Stanley",
        office: "Oficina",
        developer: "Desarrollador",
        more_documents: "Más Documentos",
        checks: "Cheques",
        claim_updates: "Actualizaciones de Reclamo",
        only_urgent: "Solo Urgente",
        attorney_update: "Actualización de Abogado",
        guilfe: "Guilfe",
      },
    },
    projects: {
      newProjectBasicInformation: {
        newSubmission: "Nuevo proyecto",
        letsGetStarted: "EMPECEMOS",
        enterUniqueName:
          "Ingrese un nombre único. Puede ser una dirección, nombre del cliente u otra información con la que pueda identificar este alcance más tarde.",
        insuredName: "Nombre y Apellido del Asegurado",
        address: "Dirección",
        addressLine2: "Línea de Dirección 2",
        city: "Ciudad",
        state: "Estado",
        zipCode: "Código Postal",
        company: "Empresa",
        confirmProjectLocation: "Confirmar Ubicación del Proyecto",
        errorOccurred: "Ha ocurrido un error, por favor intente de nuevo",
        nameRequired: "El nombre es obligatorio",
        nameMinLength: "El nombre debe tener al menos 5 caracteres",
        addressRequired: "La dirección es obligatoria",
        addressMinLength: "La dirección debe tener al menos 5 caracteres",
        cityRequired: "La ciudad es obligatoria",
        cityMinLength: "La ciudad debe tener al menos 4 caracteres",
        stateRequired: "El estado es obligatorio",
        stateMinLength: "El estado debe tener al menos 2 caracteres",
        zipRequired: "El código postal es obligatorio",
        zipMustBeNumber: "El código postal debe ser un número",
        companyRequired: "La empresa es obligatoria",
      },
      newProjectChargeData: {
        newSubmission: "Nuevo Proyecto",
        createNewFile: "Crear Nuevo proyecto",
        customer: "Información del",
        information: "Cliente",
        customerDescription:
          "Por favor complete sus datos de contacto y dirección con precisión para una comunicación y entrega de servicios eficiente.",
        uploadNow: "Subir Ahora",
        external: {
          top: "Daños",
          bottom: "Externos",
          description:
            "Suba todos los archivos relevantes relacionados con daños externos.",
        },
        internal: {
          top: "Daños",
          bottom: "Internos",
          description:
            "Suba todos los archivos relevantes relacionados con daños internos.",
        },
        project: {
          top: "Documentos del",
          bottom: "Proyecto",
          description:
            "Suba cualquier documento necesario como permisos, reclamaciones de seguro o registros de reparaciones anteriores para una visión completa del proyecto.",
        },
        submitClaim: "Cargar Reclamo",
        goToDashboard: "Ir al Tablero",
        claimSubmitted: "Reclamo cargado con éxito",
        completeLater:
          "Es esencial completar al menos la información del cliente para habilitar el botón ‘Completar Más Tarde’. Su cooperación asegura un progreso sin problemas.",
      },
      cards: {
        customerInformation: {
          newSubmission: "Nuevo Proyecto",
          customerInformation: "Información del Cliente",
          customerName: "Nombre del Cliente *",
          lossAddress: "Dirección de Pérdida",
          address: "Dirección *",
          addressLine2: "Línea de Dirección 2",
          city: "Ciudad *",
          state: "Estado *",
          zipCode: "Código Postal *",
          insuredMailingAddress: "Dirección Postal del Asegurado",
          useLossAddress: "Usar Dirección de Pérdida como Dirección Postal",
          contactInfo: "Información de Contacto",
          customerEmail: "Correo Electrónico del Cliente *",
          customerPhone: "Número de Teléfono Celular del Cliente *",
          additionalInsuredName: "Nombre Adicional del Asegurado",
          insuranceCompany: "Compañía de Seguros",
          policyNumber: "Número de Póliza",
          claimNumber: "Número de Reclamo",
          causeOfLoss: "Causa de la Pérdida",
          claimInspected:
            "¿Este Reclamo Ha Sido Inspeccionado Por La Compañía de Seguros?",
          claimReported:
            "¿Este Reclamo Ha Sido Reportado A La Compañía de Seguros?",
          dateOfLoss: "Fecha de la Pérdida o Tormenta",
          currentClaimStatus: "Estado Actual del Reclamo",
          stateOfEmergency:
            "¿Este Evento Climático Causó Que El Gobernador Declarara Un Estado de Emergencia?",
          companyCamLinks: "Enlaces de CompanyCam",
          descriptionOfLoss: "Descripción de la Pérdida / Notas del Reclamo",
          backToOptions: "Volver a Opciones",
          confirmInformation: "Confirmar Información",
          errorOccurred: "Ha ocurrido un error, por favor intente de nuevo",
          customerNameRequired: "El nombre del cliente es obligatorio",
          customerNameMinLength:
            "El nombre del cliente debe tener al menos 4 caracteres",
          addressRequired: "La dirección es obligatoria",
          addressMinLength: "La dirección debe tener al menos 5 caracteres",
          cityRequired: "La ciudad es obligatoria",
          cityMinLength: "La ciudad debe tener al menos 4 caracteres",
          stateRequired: "El estado es obligatorio",
          stateMinLength: "El estado debe tener al menos 2 caracteres",
          zipRequired: "El código postal es obligatorio",
          zipNumber: "El código postal debe ser un número",
          emailRequired: "El correo electrónico es obligatorio",
          emailValid: "El correo electrónico debe ser válido",
          phoneRequired: "El número de teléfono es obligatorio",
          phoneMinLength:
            "El número de teléfono debe tener al menos 10 caracteres",
          causeOfLossOptions: {
            hail: "Granizo",
            wind: "Viento",
            hailWind: "Granizo y Viento",
            hurricaneWind: "Viento de Huracán",
            hurricaneFlood: "Inundación de Huracán",
            flood: "Inundación",
            fire: "Fuego",
            smoke: "Humo",
            fireSmoke: "Fuego y Humo",
            fallenTree: "Árbol Caído",
            lightning: "Relámpago",
            tornado: "Tornado",
            vandalism: "Vandalismo",
            marine: "Marino",
            water: "Agua",
            other: "Otro",
          },
          claimStatusOptions: {
            new: "Nuevo",
            reopen: "Reabrir",
            denied: "Denegado",
            underDeductible: "Bajo Deducible",
          },
          stateOfEmergencyOptions: {
            stateOfEmergency:
              "Estado de Emergencia (Huracán hace 1 año o menos)",
            nonEmergency: "No Emergencia",
          },
          booleanOptions: {
            yes: "Sí",
            no: "No",
          },
          hasMortgage: "¿El propietario tiene una hipoteca?",
          mortgageName: "Nombre de la compañía hipotecaria",
          mortgageNameMinLength:
            "El nombre de la compañía hipotecaria debe tener al menos 5 caracteres",
          propertyInteriorWet:
            "¿El interior de la propiedad está mojado/húmedo?",
        },
        documents: {
          uploadDocuments: "CARGAR DOCUMENTOS",
          uploadInstructions: "Por favor, cargue sus documentos a continuación",
          uploadLabel: "Cargar Documentos",
          selectFiles: "Seleccione sus archivos",
          more: "más",
          backToOptions: "Volver a Opciones",
          confirmInformation: "Confirmar Información",
          errorOccurred: "Ha ocurrido un error, por favor intente nuevamente",
          noFilesSelected: "No se seleccionaron archivos",
          invalidFormat: "Formato de archivo inválido",
          fileSizeExceeded: `El tamaño del archivo debe ser menor a ${process.env.VUE_APP_WEIGHT_OF_FILES}MB`,
        },
        file: {
          uploadFiles: "CARGAR ARCHIVOS",
          uploadInstructions: "Por favor, cargue sus archivos a continuación",
          uploadLabel: "Cargar archivos",
          selectFiles: "Seleccione sus archivos",
          more: "más",
          backToOptions: "Volver a Opciones",
          confirmInformation: "Confirmar Información",
          errorOccurred: "Ha ocurrido un error, por favor intente nuevamente",
          noFilesSelected: "No se seleccionaron archivos",
          invalidFormat: "Formato de archivo inválido",
          fileSizeExceeded: `El tamaño del archivo debe ser menor a ${process.env.VUE_APP_WEIGHT_OF_FILES}MB`,
        },
        internalFile: {
          uploadFiles: "CARGAR ARCHIVOS",
          uploadInstructions: "Por favor, cargue sus archivos a continuación",
          uploadLabel: "Cargar archivos",
          selectFiles: "Seleccione sus archivos",
          more: "más",
          backToOptions: "Volver a Opciones",
          confirmInformation: "Confirmar Información",
          errorOccurred: "Ha ocurrido un error, por favor intente nuevamente",
          noFilesSelected: "No se seleccionaron archivos",
          invalidFormat: "Formato de archivo inválido",
          fileSizeExceeded: `El tamaño del archivo debe ser menor a ${process.env.VUE_APP_WEIGHT_OF_FILES}MB`,
        },
      },
    },
    dashboard: {
      header: {
        totalClaims: "Reclamos Totales",
        intakePending: "Pendientes de Ingreso",
        intakeRejected: "Ingresos Rechazados",
        claimOpen: "Reclamos Abiertos",
        claimClosed: "Reclamos Cerrados",
        totalWorkers: "Trabajadores Totales",
        intakeApproved: "Ingresos Aprobados",
        periods: {
          last_24h: "24h",
          last_7d: "7 días",
          last_30d: "30 días",
          all: "Todo",
        },
        current: "Actualmente",
        periodCaptions: {
          last_24h: "En las últimas 24 horas",
          last_7d: "En los últimos 7 días",
          last_30d: "En los últimos 30 días",
          all: "Actualmente",
        },
      },
      table: {
        recentHistory: "Historial Reciente",
        fullHistory: "Historial Completo",
        fullView: "Vista Completa",
        headers: {
          number: "SUB#",
          name: "Nombre",
          LOR: "LOR",
          intake: "Ingreso",
          status: "Estado",
          address: "Dirección",
          created_at: "Fecha de Creación",
          company_name: "Compañía",
        },
      },
      activities: {
        title: "Actividades",
        newUpdate: "Nueva Actualización",
        at: "En",
      },
      partners: {
        title: "Socios Destacados",
        subtitle:
          "Socios de confianza. Recursos exclusivos para contratistas de NVA.",
        viewAll: "Ver Todos los Socios",
      },
    },
    partners: {
      search: "Buscar",
      newPartner: "Nuevo Socio",
      editPartner: "Editar Socio",
      edit: "Editar",
      delete: "Eliminar",
      deleteTitle: "Eliminar Socio",
      deleteConfirm: "¿Seguro que deseas eliminar a {company}?",
      image: "Imagen del Banner",
      imageHint: "JPG, PNG o WebP · máx. 10 MB · recomendado 1800×300 px",
      imageInfo: {
        title: "Requisitos de la imagen del banner",
        formats: "Formato: JPG, PNG o WebP.",
        size: "Peso máximo: 10 MB.",
        ratio:
          "Banner horizontal: el ancho debe ser entre 4 y 8 veces el alto. Recomendado 1800×300 px.",
        spotlight:
          "Obligatoria para mostrar el socio en el tablero. Al hacer clic se abre su sitio web.",
      },
      spotlight: "Mostrar en el tablero",
      spotlightHint:
        "Solo se muestra un socio en el tablero; este reemplaza al actual.",
      spotlightChip: "En tablero",
      close: "Cerrar",
      save: "Guardar",
      errorOccurred: "Ocurrió un error. Por favor, inténtelo de nuevo.",
      headers: {
        company: "Compañía",
        service: "Servicio",
        contact: "Contacto/Agente",
        phone_number: "Teléfono",
        email: "Correo Electrónico",
        website: "Sitio Web",
      },
      validation: {
        required: "Este campo es obligatorio",
        email: "El correo electrónico debe ser válido",
        website: "El sitio web debe comenzar con http:// o https://",
        imageRequired:
          "Se requiere una imagen para mostrar este socio en el tablero",
        imageType: "Solo se permiten imágenes JPG, PNG o WebP",
        imageSize: "La imagen debe pesar 10 MB o menos",
        imageRatio:
          "La imagen debe ser un banner horizontal (entre 4:1 y 8:1, recomendado 1800×300 px)",
      },
    },
    companies: {
      search: "Buscar",
      newCompany: "Nueva Empresa",
      name: "Nombre",
      email: "Correo Electrónico",
      address: "Dirección",
      phoneNumber: "Número de Teléfono",
      types: "Tipos",
      sellers: "Vendedores",
      representative: "Representante",
      notes: "Notas",
      errorOccurred: "Ocurrió un error, por favor intente nuevamente",
      close: "Cerrar",
      save: "Guardar",
      createAdmin: "Crear Admin",
      editCompany: "Editar Empresa",
      companyHistory: "Historial de la Empresa",
      headers: {
        name: "Nombre",
        email: "Correo Electrónico",
        address: "Dirección",
        phone_number: "Número de Teléfono",
        created_at: "Fecha de Creación",
        company_type: "Tipo de Empresa",
        sellers: "Vendedores",
        representative: "Representante",
      },
      validation: {
        name: {
          required: "El nombre es obligatorio",
          minLength: "El nombre debe tener al menos 3 caracteres",
        },
        email: {
          required: "El correo electrónico es obligatorio",
          valid: "El correo electrónico debe ser válido",
        },
        address: {
          required: "La dirección es obligatoria",
          minLength: "La dirección debe tener al menos 5 caracteres",
        },
        phone: {
          required: "El número de teléfono es obligatorio",
          minLength: "El número de teléfono debe tener al menos 5 caracteres",
        },
      },
      typesOptions: {
        roofing: "Techo",
        mitigation: "Mitigación",
        remodeling: "Remodelación",
        other: "Otro",
      },
      sellersOptions: {
        "1-5": "1-5",
        "6-15": "6-15",
        "15+": "15+",
      },
    },
    team: {
      teamInfo: {
        search: "Buscar",
        newMember: "Nuevo miembro",
        headers: {
          entry_date: "Fecha de Entrada",
          job_title: "Título del Trabajo",
          claims: "Reclamos",
          name: "Nombre",
          email: "Correo Electrónico",
          phone: "Teléfono",
        },
      },
      createMember: {
        newMember: "Nuevo miembro",
        name: "Nombre",
        email: "Correo Electrónico",
        phoneNumber: "Teléfono",
        password: "Contraseña",
        confirmationPassword: "Confirmar Contraseña",
        entryDate: "Fecha de Entrada",
        jobTitle: "Título del Trabajo",
        confirmAccount: "Confirmar Cuenta",
        accountCreated: "La cuenta ha sido creada.",
        createAnotherAccount: "Crear otra cuenta",
        viewCompanies: "Ver Compañías",
        viewTeam: "Ver equipo",
        accountCreationFailed: "Falló la creación de la cuenta.",
        tryAgain: "Inténtalo de nuevo",
        validation: {
          name: {
            required: "El nombre es obligatorio",
            minLength: "El nombre debe tener al menos 5 caracteres",
          },
          email: {
            required: "El correo electrónico es obligatorio",
            valid: "El correo electrónico debe ser válido",
          },
          phone: {
            required: "El teléfono es obligatorio",
            minLength: "El teléfono debe tener al menos 5 caracteres",
          },
          password: {
            required: "La contraseña es obligatoria",
            minLength: "La contraseña debe tener al menos 5 caracteres",
          },
          confirmationPassword: {
            required: "La confirmación de la contraseña es obligatoria",
            match: "Las contraseñas deben coincidir",
          },
          date: {
            required: "La fecha es obligatoria",
          },
          jobTitle: {
            required: "El título del trabajo es obligatorio",
            minLength: "El título del trabajo debe tener al menos 5 caracteres",
          },
        },
      },
    },
    history: {
      principalHistory: {
        recentHistory: "Historial Reciente",
        fullHistory: "Historial Completo",
        headers: {
          number: "SUB#",
          name: "Nombre",
          LOR: "LOR",
          intake: "Ingreso",
          status: "Estado",
          address: "Dirección",
          created_at: "Fecha de Creación",
          company_name: "Empresa",
        },
        fullView: "Vista Completa",
        editName: "Editar Nombre",
        editProject: "Editar Proyecto",
        close: "Cerrar",
        save: "Guardar",
        validation: {
          name: {
            required: "El nombre es obligatorio",
            minLength: "El nombre debe tener al menos 5 caracteres",
          },
        },
        errorOccurred: "Ocurrió un error, por favor intente de nuevo",
        projectUpdated: "El proyecto se ha actualizado correctamente",
        search: "Buscar",
        all: "Todos",
        pending: "Pendiente",
        rejected: "Rechazado",
        incomplete: "Incompleto",
        status: "Abierto",
        negotiation: "Negociación",
        appraisal: "Avalúo",
        depreciation: "Depreciación",
        appraisalOnly: "Solo Avalúo",
        attorney: "Abogado",
        pendingNotifications: "Notificaciones Pendientes",
        filters: "Filtros",
        otherFilters: "Otros",
      },
      fullView: {
        details: "Detalles",
        contacts: "Contactos",
        files: "Archivos",
        forms: "Formularios",
        config: "Estatus",
        downloadImage: "Descargar Imagen",
        editProjectName: "Editar Nombre del Proyecto",
        name: "Nombre",
        save: "Guardar",
        close: "Cerrar",
        errorOccurred: "Ocurrió un error, por favor intente de nuevo",
        projectUpdated:
          "El nombre del proyecto se ha actualizado correctamente",
      },
      elements: {
        header: {
          client: "Cliente",
          subNumber: "Nombre de la Empresa",
          claimStatus: "Estado del Reclamo",
          totalPayments: "Pagos Totales",
          lastPayment: "Último pago",
        },
        details: {
          insuredInfo: "Información del Asegurado",
          editCustomer: "Editar Cliente",
          claimInfo: "Información del Reclamo",
          update: "Actualizaciones",
          payments: "Pagos",
          timeline: "Cronología",
          name: "Nombre",
          email: "Correo Electrónico",
          phone: "Teléfono",
          insuredAddress: "Dirección del Asegurado",
          lossAddress: "Dirección de Pérdida",
          causeOfLoss: "Causa de la Pérdida",
          lossDescription: "Descripción de la Pérdida / Notas del Reclamo",
          companycamLinks: "Enlaces de Companycam",
          claimNumber: "Número de Reclamo",
          claimStatus: "Estado del Reclamo",
          dateOfLoss: "Fecha de Pérdida o Tormenta",
          inspectedByInsurance: "Inspeccionado por la Compañía de Seguros",
          reportedToInsurance: "Reportado a la Compañía de Seguros",
          insuranceCompany: "Compañía de Seguros",
          policyNumber: "Número de Póliza",
          stateOfEmergency: "Estado de Emergencia",
          hasMortgage: "Tiene Hipoteca",
          mortgageCompany: "Nombre de la Compañía Hipotecaria",
          propertyInteriorWet: "Interior de la Propiedad Mojado/Húmedo",
          yes: "Sí",
          no: "No",
          payment: {
            total: "Total",
            amount: "Monto del Pago",
            description: "Descripción del Pago",
            detail: "Detalle del Pago",
            upload: "Subir archivos",
            newPayment: "Nuevo Pago",
            attachments: "Adjuntos",
            reply: "Responder",
            replyDetail: "Detalle de Respuesta",
            sendReply: "Enviar Respuesta",
            error: "Ha ocurrido un error, por favor intenta nuevamente",
            replyError:
              "Hubo un error al enviar tu respuesta. Por favor intenta nuevamente.",
            success: "Estado e Ingreso actualizados con éxito",
            department: "Departamento",
            office: "Oficina",
            intake: "Admisión",
            inspections: "Inspecciones",
            estimation: "Estimación",
            roofer_relations: "Relaciones con Techadores",
            check_support: "Soporte de Cheques",
            appraisal: "Evaluación",
            management: "Gestión",
            supplementing: "Suplementación",
            sales: "Ventas",
            stanley: "Stanley",
            more_documents: "Más Documentos",
            checks: "Cheques",
            claim_updates: "Actualizaciones de Reclamo",
            only_urgent: "Solo Urgente",
            attorney_update: "Actualización de Abogado",
            guilfe: "Guilfe",
            validation: {
              amountRequired: "El monto del pago es obligatorio",
              descriptionRequired: "La descripción del pago es obligatoria",
              detailRequired: "El detalle del pago es obligatorio",
              maxFiles: `Solo puedes subir hasta ${process.env.VUE_APP_NUMBER_OF_FILES} archivos`,
              maxFileSize: `Cada archivo debe ser menor de ${process.env.VUE_APP_WEIGHT_OF_FILES}MB`,
              replyRequired: "El detalle de la respuesta es obligatorio",
              departmentRequired: "El departamento es obligatorio",
            },
            deletePayment: "Eliminar Pago",
            deletePaymentConfirmation:
              "¿Estás seguro de que deseas eliminar este pago?",
            deleteComment: "Eliminar Comentario",
            deleteCommentConfirmation:
              "¿Estás seguro de que deseas eliminar este comentario?",
            confirm: "Confirmar",
            cancel: "Cancelar",
          },
          updates: {
            threadDetail: "Detalle del hilo",
            upload: "Subir archivos",
            createThread: "Crear hilo",
            attachments: "Adjuntos",
            reply: "Responder",
            replyDetail: "Detalle de la respuesta",
            sendReply: "Enviar respuesta",
            error: "Ha ocurrido un error, por favor intenta nuevamente",
            replyError:
              "Hubo un error al enviar tu respuesta. Por favor intenta nuevamente.",
            department: "Departamento",
            office: "Oficina",
            intake: "Admisión",
            inspections: "Inspecciones",
            estimation: "Estimación",
            roofer_relations: "Relaciones con Techadores",
            check_support: "Soporte de Cheques",
            appraisal: "Evaluación",
            management: "Gestión",
            supplementing: "Suplementación",
            sales: "Ventas",
            stanley: "Stanley",
            more_documents: "Más Documentos",
            checks: "Cheques",
            claim_updates: "Actualizaciones de Reclamo",
            only_urgent: "Solo Urgente",
            attorney_update: "Actualización de Abogado",
            guilfe: "Guilfe",
            validation: {
              threadRequired: "El detalle del hilo es obligatorio",
              maxFiles: `Solo puedes subir hasta ${process.env.VUE_APP_NUMBER_OF_FILES} archivos`,
              maxFileSize: `Cada archivo debe ser menor de ${process.env.VUE_APP_WEIGHT_OF_FILES}MB`,
              replyRequired: "El detalle de la respuesta es obligatorio",
              departmentRequired: "El departamento es obligatorio",
            },
            deleteThread: "Eliminar hilo",
            deleteThreadConfirmation:
              "¿Estás seguro de que deseas eliminar este hilo?",
            deleteComment: "Eliminar comentario",
            deleteCommentConfirmation:
              "¿Estás seguro de que deseas eliminar este comentario?",
            confirm: "Confirmar",
            cancel: "Cancelar",
          },
          timelines: {
            ClaimUpdated: "Reclamo Actualizado",
            ClaimCreated: "Reclamo Creado",
            FileUploaded: "Archivo Subido",
            ContactsUpdated: "Contactos actualizados",
            claimStatusUpdated: "Estado del reclamo actualizado: {status}",
            claimIntakeUpdated: "Ingreso actualizado: {intake}",
            Comment: "Comentario",
            Payment: "Pago",
            filterByDepartment: "Filtrar por Departamento",
            allDepartments: "Todos los Departamentos",
            office: "Oficina",
            intake: "Admisión",
            inspections: "Inspecciones",
            estimation: "Estimación",
            roofer_relations: "Relaciones con Techadores",
            check_support: "Soporte de Cheques",
            appraisal: "Evaluación",
            management: "Gestión",
            supplementing: "Suplementación",
            sales: "Ventas",
            stanley: "Stanley",
            more_documents: "Más Documentos",
            checks: "Cheques",
            claim_updates: "Actualizaciones de Reclamo",
            only_urgent: "Solo Urgente",
            attorney_update: "Actualización de Abogado",
            guilfe: "Guilfe",
            other: "Otros",
          },
        },
        contacts: {
          internalContacts: "Contactos Internos",
          addMoreContacts: "Agregar Más Contactos",
          manageContacts: "Administrar Contactos",
          cancel: "Cancelar",
          save: "Guardar",
          headers: {
            name: "Nombre",
            job_title: "Puesto",
            email: "Correo Electrónico",
            phone: "Teléfono",
          },
        },
        files: {
          files: "Archivos",
          addNew: "Agregar Nuevo",
          folder: "Carpeta",
          addNewFolder: "Agregar Nueva Carpeta",
          folderName: "Nombre de la Carpeta",
          cancel: "Cancelar",
          save: "Guardar",
          upload: "Subir",
          close: "Cerrar",
          uploadDocuments: "Subir Documentos",
          selectDocuments: "Seleccionar documentos",
          downloadAll: "Descargar como Zip",
          downloadAllImages: "Descargar como PDF",
          uploadLimit: `Solo puedes subir hasta ${process.env.VUE_APP_NUMBER_OF_FILES} archivos`,
          fileSizeLimit: `Cada archivo debe ser menor de ${process.env.VUE_APP_WEIGHT_OF_FILES}MB`,
          folderCreated: "Carpeta creada con éxito",
          documentUploaded: "Documento subido con éxito",
          documentDeleted: "Documento eliminado con éxito",
          errorOccurred: "Ha ocurrido un error, por favor intenta nuevamente",
          delete: "Eliminar Archivo",
          edit: "Editar Nombre",
          editDocument: "Editar Nombre del Archivo",
          documentEdited: "Nombre del archivo editado con éxito",
          documentName: "Nombre del Archivo",
          requiredName: "El nombre es obligatorio",
        },
        forms: {
          lor: "LOR",
          noLOR:
            "No se encontró registro de la Carta de Representación para este Proyecto.",
          resend: "Reenviar",
          error: "Ha ocurrido un error, por favor intenta nuevamente",
          success: "LOR enviada con éxito",
          email_send_date: "Fecha de envío del correo electrónico",
          email_status: "Estado del correo electrónico",
          reminder_sent_date: "Fecha de envío del recordatorio",
          status: "Estado",
          Sent: "Enviado",
          Unsigned: "No firmado",
          Signed: "Firmado",
        },
        config: {
          editStatusAndIntake: "Editar Estado e Ingreso",
          status: "Estado",
          intake: "Ingreso",
          update: "Actualizar",
          error: "Ha ocurrido un error, por favor intenta nuevamente",
          success: "Estado e Ingreso actualizados con éxito",
          statusOptions: {
            open: "Abierto",
            closed: "Cerrado",
            tbd: "TBD",
            inspection: "Inspección",
            negotiations: "Negociaciones",
            appraisal: "Valoración",
            settled: "Acuerdo",
            depreciation: "Depreciación",
            appraisal_only: "Solo Avalúo",
            attorney: "Abogado",
          },
          intakeOptions: {
            approved: "Aprobado",
            pending: "Pendiente",
            rejected: "Rechazado",
            incomplete: "Incompleto",
          },
        },
      },
    },
    activities: {
      search: "Buscar",
      headers: {
        creator: "Creador",
        date: "Fecha",
        event: "Evento",
        project: "Reclamo",
      },
      fullView: "Vista Completa",
    },
    termsAndConditions: {
      title: "Términos y Condiciones",
      subtitle: "National Virtual Adjusters LLC",
      content: {
        intro:
          'Valoramos la transparencia, integridad y profesionalismo en todas las relaciones con proveedores. Este reconocimiento asegura el entendimiento mutuo y protege a todas las partes involucradas—National Virtual Adjusters LLC ("NVA"), firmas de ajustadores públicos licenciados, y usted como proveedor. Al aceptar los términos a continuación, usted nos ayuda a mantener altos estándares y prácticas éticas en el servicio a propietarios de viviendas.',
        statement:
          'Esta Declaración de Reconocimiento y Divulgación ("Declaración") es hecha por el proveedor firmante ("Proveedor") en conexión con la provisión de leads de reclamos de seguros a National Virtual Adjusters LLC ("NVA"), una compañía que facilita conexiones entre contratistas de techos y firmas de ajustadores públicos licenciados, incluyendo pero no limitado a Cohen and Associates Public Adjusters Inc, y cualquier otra firma de ajustadores públicos licenciados operando en cualquier estado de EE.UU.',
        acknowledgment:
          "Al firmar a continuación, el Proveedor por la presente reconoce, afirma y acepta lo siguiente:",
        section1: {
          title: "1. Legitimidad y Origen Legal de los Leads",
          text: "• Todos los leads proporcionados a National Virtual Adjusters LLC, Cohen and Associates Public Adjusters Inc, o cualquier otra firma de ajustadores públicos licenciados operando en cualquier estado de EE.UU.—ya sea en el pasado, presente o futuro—son obtenidos a través de medios legales, éticos y transparentes.\n• Ningún lead es fraudulento, fabricado o destinado a engañar o tergiversar la naturaleza del reclamo de seguro.\n• Cada lead representa a un propietario legítimo con un reclamo de seguro de propiedad válido o potencial.",
        },
        section2: {
          title: "2. Sin Fraude o Engaño",
          text: "• El Proveedor no participará en ninguna actividad que engañe, defraude o tergiverse información a:\n• National Virtual Adjusters LLC o cualquiera de sus miembros, representantes o afiliados\n• Cohen and Associates Public Adjusters Inc o cualquiera de sus ajustadores licenciados, personal o representantes\n• Cualquier otra firma de ajustadores públicos licenciados operando en cualquier estado de EE.UU.\n• Los propietarios que son clientes o clientes potenciales de cualquiera de las entidades mencionadas\n• El Proveedor no presentará o describirá el papel de NVA de una manera que pueda causar confusión o engañar a los propietarios con respecto a su estado de licencia o función.",
        },
        section3: {
          title: "3. Representación Clara a los Propietarios",
          text: "• El Proveedor asegurará que los propietarios entiendan que un ajustador público licenciado es responsable de manejar su reclamo de seguro.\n• El Proveedor reconoce que National Virtual Adjusters LLC sirve como conector entre contratistas de techos y firmas de ajustadores públicos licenciados, incluyendo pero no limitado a Cohen and Associates Public Adjusters Inc y otras firmas de ajustadores públicos licenciados en cualquier estado de EE.UU. NVA no es un ajustador público licenciado. El Proveedor acepta representar esta estructura con precisión para ayudar a los propietarios a entender quién está manejando su reclamo y quién está facilitando la conexión.",
        },
        section4: {
          title: "4. Sin Afiliación Comercial o Conflicto de Intereses",
          text: "• El Proveedor reconoce que no existe una asociación comercial, empresa conjunta, relación de agencia o acuerdo de empleo entre el Proveedor y National Virtual Adjusters LLC, Cohen and Associates Public Adjusters Inc, o cualquier otra firma de ajustadores públicos licenciados.\n• Cualquier representación o implicación de tal relación está estrictamente prohibida y constituye un conflicto de intereses.\n• El Proveedor divulgará cualquier conflicto de intereses potencial que pueda surgir en conexión con los leads proporcionados.",
        },
        section5: {
          title: "5. Indemnización",
          text: "• El Proveedor acepta indemnizar y eximir de responsabilidad a National Virtual Adjusters LLC, Cohen and Associates Public Adjusters Inc, cualquier otra firma de ajustadores públicos licenciados, y todos sus respectivos miembros, ajustadores, oficiales y afiliados de cualquier reclamo, daño o responsabilidad que surja de o esté relacionado con la provisión de leads fraudulentos, engañosos o obtenidos incorrectamente.",
        },
        section6: {
          title: "6. Entendimiento y Cumplimiento",
          text: "• El Proveedor afirma que ha leído, entendido y aceptado los términos de esta Declaración.\n• El Proveedor acepta cumplir con todas las leyes, regulaciones y estándares éticos aplicables en la adquisición y entrega de leads.",
        },
        section7: {
          title: "7. Jurisdicción y Aplicabilidad",
          text: "• Esta Declaración será regida e interpretada de acuerdo con las leyes del estado de EE.UU. en el que opera la firma de ajustadores públicos licenciados involucrada en la transacción.\n• Sin embargo, donde sea permisible, las partes acuerdan someterse a la jurisdicción exclusiva y sede de los tribunales del Estado de Florida, específicamente el Condado de Broward, Florida.\n• Las partes acuerdan que esta Declaración es legalmente vinculante y ejecutable.",
        },
        section8: {
          title: "8. Derechos de Auditoría y Verificación",
          text: "• National Virtual Adjusters LLC, Cohen and Associates Public Adjusters Inc, o cualquier otra firma de ajustadores públicos licenciados se reservan el derecho de solicitar documentación o verificación del origen de leads y métodos de adquisición en cualquier momento.\n• El Proveedor acepta cooperar completamente con cualquier solicitud de este tipo para asegurar el cumplimiento y la transparencia.",
        },
        section9: {
          title: "9. Consecuencias del Incumplimiento",
          text: "• Cualquier incumplimiento de esta Declaración por parte del Proveedor puede resultar en la terminación inmediata de la relación con National Virtual Adjusters LLC, Cohen and Associates Public Adjusters Inc, o cualquier otra firma de ajustadores públicos licenciados.\n• La terminación puede ocurrir sin aviso previo si el incumplimiento representa un riesgo para el cumplimiento legal, estándares éticos o la reputación de las partes involucradas.",
        },
        section10: {
          title: "10. Validez del Reconocimiento Electrónico",
          text: "• Las partes acuerdan que el reconocimiento de esta Declaración a través de medios electrónicos—incluyendo marcar una casilla durante el proceso de registro del proveedor—será considerado válido y ejecutable bajo la Ley de Firmas Electrónicas en el Comercio Global y Nacional (ESIGN) y la Ley Uniforme de Transacciones Electrónicas (UETA).",
        },
        section11: {
          title: "11. Honorarios de Abogados y Costos",
          text: "• Si cualquier parte mantiene o inicia cualquier acción, procedimiento o moción contra la otra para hacer cumplir esta Declaración o cualquier disposición de la misma, la parte prevaleciente tendrá derecho a recuperar sus costos y gastos, incluyendo honorarios de mediación, costos de litigio, honorarios judiciales y honorarios razonables de abogados incurridos en conexión con tal acción.",
        },
        acceptance:
          "Al hacer clic en 'Aceptar', usted reconoce que ha leído, entendido y acepta estar sujeto a esta Declaración de Reconocimiento y Divulgación para Proveedores de Leads.",
      },
      acceptMessage:
        "Por favor acepta estos términos para continuar usando la plataforma.",
      accept: "Aceptar",
      reject: "Rechazar",
      viewTerms: "Ver Términos",
      hideTerms: "Ocultar Términos",
    },
  },
};

// Configuration of vue-i18n
const i18n = new VueI18n({
  locale: "en", // idioma por defecto
  messages,
});

export default i18n;
